import styles from './Mascot.module.css'

/** Panel-Maskottchen — nutzt die vom Team bereitgestellte Katzen-Illustration
 * (public/mascot-cat.png, aus Racoon.svg extrahiert) statt eines selbst gezeichneten Bilds.
 * Da es ein einzelnes, bereits zusammengeführtes Bild ist (keine getrennten Ohr-/Augen-
 * Ebenen), wird es als Ganzes animiert: Eintritt (fade+scale) und ein dauerhaftes, leichtes
 * Schweben. Der Glow dahinter bleibt themefarbig (`--glow-accent`), damit die Katze trotz
 * fixem Bild noch auf das aktive Theme reagiert. */
export function Mascot({ size = 96, className }: { size?: number; className?: string }) {
  return (
    <div className={[styles.wrap, className].filter(Boolean).join(' ')} style={{ width: size, height: size }}>
      <div className={styles.glow} />
      <img src="/mascot-cat.png" alt="" className={styles.img} width={size} height={size} />
    </div>
  )
}
